"use strict";

jQuery(document).on("custom_DKT_libraries_loaded", function() {
  DKTGeoLocation.init();
  DKTNotices.init();
});
